module.exports = __webpack_public_path__ + "static/media/icomoon.2bb5a00b.svg";